// src/contexts/LoaderContext.js
import { createContext, useContext, useState, useEffect } from 'react';
import { Box, Flex, keyframes, Image } from '@chakra-ui/react';
import { loaderService } from '../services/loaderService';
import logo from '../assets/img/layout/loader.png';

const LoaderContext = createContext();

export const useLoader = () => useContext(LoaderContext);

// Animación de giro
const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const onChange = (value) => setLoading(value);
    loaderService.on('change', onChange);
    return () => {
      loaderService.off('change', onChange);
    };
  }, []);

  return (
    <LoaderContext.Provider value={{ loading }}>
      {children}
      {loading && (
        <Flex
          position="fixed"
          top={0}
          left={0}
          width="100vw"
          height="100vh"
          bg="rgba(255, 255, 255, 0.72)"
          align="center"
          justify="center"
          zIndex={9999}
        >
          <Box
            position="relative"
            width="120px"
            height="120px"
            p={6}
            borderRadius="50%"
            // border="5px solid rgba(136, 136, 136, 0.3)"
            _after={{
              content: '""',
              position: 'absolute',
              top: '0',
              left: '0%',
              width: '125px',
              height: '125px',
              borderRadius: '50%',
              border: '5px solid rgba(0, 48, 100, 0.73)',
              borderTopColor: 'white',
              animation: `${spin} 1s linear infinite`,
              transform: 'translate(-50%, -50%)',
            }}
          >
            <Image
              src={logo}
              alt="Logo"
              boxSize="45px"
              position="absolute"
              top="57%"
              left="56%"
              transform="translate(-50%, -50%)"
              zIndex="1"
            />
          </Box>
        </Flex>
      )}
    </LoaderContext.Provider>
  );
};
